<template>
  <div :class="clContainer()">
    <span
      v-if="label && (!hideLabelState || state != hideLabelState)"
      :class="clSub('label', 'label')"
      >{{ label }}</span
    >
    <p :class="clSub('value', textClass)">{{ text }}</p>

    <textarea
      :id="id"
      :class="clSub('input', `form__input ${inputClass}`)"
      :name="name"
      :placeholder="placeholder"
      :tabindex="tabindex"
      :style="{ height }"
      v-model="data"
      @input="
        dataChanged(true);
        validate();
      "
      @focus="focused"
      spellcheck="false"
    >
    </textarea>

    <slot name="append" :state="state"></slot>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";

export default {
  extends: Base,
  props: {
    type: {
      type: String,
      default: "text",
    },
    typeClass: {
      type: String,
      default: "input",
    },
    height: {
      type: String,
    },
    disabeld: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputClass: "",
    };
  },
  methods: {
    focused() {
      this.inputClass = "focused";
      this.validate();
    },
  },
};
</script>